const fonts = {
  body: "Plus Jakarta Sans",
};

export { fonts };
